define('core/templates/postMediaUploads',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<ul data-role=\"media-progress-list\"></ul>\n<ul data-role=\"media-rich-list\"></ul>\n<div class=\"media-expanded empty\" data-role=\"media-preview-expanded\">\n<img src=\"data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==\"\ndata-role=\"media-preview-expanded-image\" alt=\""
    + container.escapeExpression(helpers.gettext.call(depth0 != null ? depth0 : {},"Media preview placeholder",{"name":"gettext","hash":{},"data":data}))
    + "\">\n</div>\n";
},"useData":true})

});
